import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Star, CheckCircle2, ArrowRight } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
const contactInfo = [{
  icon: Phone,
  label: 'Llamanos o Escribenos',
  value: '+1 (407) 367-8672'
}, {
  icon: Mail,
  label: 'Correo Oficial',
  value: 'eduardo@vantixcreditsolutions.com'
}, {
  icon: MapPin,
  label: 'Servicio',
  value: 'Completamente Hecho Para Ti'
}];
const consultaItems = ['Revisamos tu situacion actual y metas', 'Identificamos oportunidades rapidas', 'Te damos un plan claro sin compromiso', 'Sin presion, sin venta agresiva'];
const sessionStats = [{
  value: '30 min',
  label: 'Duracion'
}, {
  value: 'Gratis',
  label: 'Sin costo'
}, {
  value: '100%',
  label: 'Confidencial'
}];
export function Booking() {
  return <section id="agendar" className="bg-black py-32 px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-14" data-mp="1f94seyjxj5mn">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-15" data-mp="1mvyotcpg09ln" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-16" data-mp="20u573khws107">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-17" data-mp="1vw3n8xcnrxno">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-18" data-mp="1d4u9uczrooqt">
            Comienza Ahora
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-19" data-mp="kgopvsgjf3s1">
            Has Llegado Hasta Aqui.
            <br data-id="element-20" data-mp="2pike9sv1esld" />
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-21" data-mp="2pi0u05hwzs46">
              Ahora Toma Accion.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-22" data-mp="2yb45i8901uw6">
            Agenda tu consulta gratuita y recibe un plan de accion personalizado
            para tu credito.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-23" data-mp="26k8361kkf8n5">
          {/* Left: contact info + checklist */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="space-y-8 order-2 lg:order-1" data-id="element-24" data-mp="2anml4xs2dz38">
            {/* Contact rows */}
            <div className="space-y-5" data-id="element-25" data-mp="12h7aznsgln">
              {contactInfo.map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-26" data-mp="3rbu9khr3hixp" data-mpi={i}>
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center shrink-0" data-id="element-27" data-mp="3nb0kvm5tw03r">
                    <item.icon className="h-5 w-5 text-amber-400" strokeWidth={2} data-id="element-28" data-mp="3ddcm8l53q8gb" />
                  </div>
                  <div data-id="element-29" data-mp="38gm6jyx7levf">
                    <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-1" data-id="element-30" data-mp="34dpk1x4jsym7">
                      {item.label}
                    </div>
                    <div className="text-white font-semibold text-lg" data-id="element-31" data-mp="16l3hpuptf0kn">
                      {item.value}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* En tu consulta box */}
            <div className="rounded-3xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8" data-id="element-32" data-mp="1en2p1yfg7g8e">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-6" data-id="element-33" data-mp="10nt7aublge2b">
                En tu consulta:
              </div>
              <ul className="space-y-4" data-id="element-34" data-mp="qy1bxxvo7gws">
                {consultaItems.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-35" data-mp="vozw58js4z5b" data-mpi={i}>
                    <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-36" data-mp="vrcngcbfglv1" />
                    <span className="text-white/70 font-light" data-id="element-37" data-mp="m0hwwvr5f03s">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Right: booking card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="rounded-3xl border border-amber-500/30 bg-gradient-to-b from-amber-500/[0.06] to-transparent shadow-2xl shadow-amber-500/5 p-8 md:p-12 text-center order-1 lg:order-2" data-id="element-38" data-mp="cxgvh8d89x6g">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-39" data-mp="7ana9k7tvv4b">
              Agenda Tu Sesion{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-40" data-mp="m3gufiy1ozfb">
                Gratis
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-10 max-w-md mx-auto" data-id="element-41" data-mp="v095xxozrs7k">
              Selecciona el dia y hora que mejor te convenga. En 30 minutos
              tendras claridad total sobre tu camino a un mejor credito y
              financiamiento.
            </p>

            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-8 py-4 rounded-full transition-all text-lg shadow-2xl shadow-amber-500/30 w-full" data-id="element-42" data-mp="3ouk2p437xtav">
              Reservar Mi Consulta Gratis
              <ArrowRight className="h-5 w-5" data-id="element-43" data-mp="gerw6c2ij3k3" />
            </a>
            <p className="mt-5 text-sm text-white/40 font-light" data-id="element-44" data-mp="gf9zttri8k21">
              Sin spam. Tu informacion es 100% confidencial.
            </p>

            {/* Divider */}
            <div className="h-px w-full bg-white/[0.08] my-10" data-id="element-45" data-mp="2i6wvw9q9755d" />

            {/* Session stats */}
            <div className="grid grid-cols-3 gap-4" data-id="element-46" data-mp="2m8i7lrr1xddz">
              {sessionStats.map((stat, i) => <div key={i} data-id="element-47" data-mp="2eopov66ynymi" data-mpi={i}>
                  <div className="text-xl md:text-2xl font-bold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-1" data-id="element-48" data-mp="2eq0t174bj8e5">
                    {stat.value}
                  </div>
                  <div className="text-sm text-white/40 font-light" data-id="element-49" data-mp="24w1pc3oljgk3">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}